import { render, staticRenderFns } from "./BannerShortcutFormLinkItem.vue?vue&type=template&id=8bf8c968&scoped=true&"
import script from "./BannerShortcutFormLinkItem.vue?vue&type=script&lang=js&"
export * from "./BannerShortcutFormLinkItem.vue?vue&type=script&lang=js&"
import style0 from "./BannerShortcutFormLinkItem.vue?vue&type=style&index=0&id=8bf8c968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf8c968",
  null
  
)

export default component.exports